import type { LegalSection } from "@/types/content";
import { siteConfig } from "@/config/site.config";

export const LEGAL_UPDATED = "February 2026";

export const privacySections: LegalSection[] = [
  {
    heading: "1. Introduction",
    paragraphs: [
      `This Privacy Policy explains how ${siteConfig.legalName} ("we", "us", "our") collects, uses and protects information when you visit our website or contact us. We are committed to handling your information responsibly and transparently.`,
    ],
  },
  {
    heading: "2. Information we collect",
    paragraphs: [
      "Information you provide directly — such as your name, email, company and message when you submit our contact form.",
      "Technical and usage information collected automatically, such as your browser type, referring page and general interaction data used to improve the site.",
      "Marketing attribution data (for example, UTM campaign parameters) when present in the link you arrive from.",
    ],
  },
  {
    heading: "3. How we use your information",
    paragraphs: [
      "To respond to your enquiries and provide the services you request.",
      "To understand how our site is used so we can improve it.",
      "To communicate relevant updates where you have agreed to hear from us.",
    ],
  },
  {
    heading: "4. Legal basis and consent",
    paragraphs: [
      "We process personal information on the basis of your consent, our legitimate interest in operating and improving our business, and to fulfil requests you make of us. You may withdraw consent at any time.",
    ],
  },
  {
    heading: "5. Data sharing",
    paragraphs: [
      "We do not sell your personal information. We may share it with trusted service providers (such as email delivery) strictly to operate our services, and where required by law.",
    ],
  },
  {
    heading: "6. Data retention and security",
    paragraphs: [
      "We retain personal information only as long as necessary for the purposes described here, then delete or anonymise it. We apply appropriate technical and organisational measures to protect your data.",
    ],
  },
  {
    heading: "7. Your rights",
    paragraphs: [
      "Depending on your location, you may have rights to access, correct, delete or restrict the processing of your personal information, and to data portability. To exercise these rights, contact us using the details below.",
    ],
  },
  {
    heading: "8. Contact us",
    paragraphs: [
      `If you have questions about this policy or your data, contact us at ${siteConfig.contact.email}.`,
    ],
  },
];

export const termsSections: LegalSection[] = [
  {
    heading: "1. Agreement to terms",
    paragraphs: [
      `These Terms of Service govern your use of the ${siteConfig.legalName} website. By accessing or using the site, you agree to be bound by these terms. If you do not agree, please do not use the site.`,
    ],
  },
  {
    heading: "2. Use of the website",
    paragraphs: [
      "You may use this website for lawful purposes only. You agree not to misuse the site, attempt to disrupt it, or access it in any way that could damage or impair its availability.",
    ],
  },
  {
    heading: "3. Intellectual property",
    paragraphs: [
      "All content on this website — including text, design, graphics and code — is owned by or licensed to us and protected by applicable intellectual property laws. You may not reproduce or redistribute it without permission.",
    ],
  },
  {
    heading: "4. Concept work disclaimer",
    paragraphs: [
      'Projects and case studies shown on this site are labelled "Concept Project" and are illustrative works created to demonstrate our capabilities. They do not represent specific client engagements unless explicitly stated.',
    ],
  },
  {
    heading: "5. Services and estimates",
    paragraphs: [
      "Any estimates, timelines or descriptions of services on this site are provided for general information and do not constitute a binding offer. Engagements are governed by a separate written agreement.",
    ],
  },
  {
    heading: "6. Limitation of liability",
    paragraphs: [
      "The website is provided on an \"as is\" basis. To the fullest extent permitted by law, we exclude liability for any loss or damage arising from your use of, or reliance on, this website.",
    ],
  },
  {
    heading: "7. Third-party links",
    paragraphs: [
      "This site may link to third-party websites. We are not responsible for the content or practices of those sites and encourage you to review their terms and policies.",
    ],
  },
  {
    heading: "8. Changes and contact",
    paragraphs: [
      `We may update these terms from time to time. Continued use of the site constitutes acceptance of the revised terms. Questions? Contact us at ${siteConfig.contact.email}.`,
    ],
  },
];
